import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const BodyMask = ({ className, onClick, onKeyUp }) => {
	const [currentClassName, setClassName] = useState(className);
	useEffect(() => {
		setClassName(className);
	}, [className]);
	return (
		<div
			className={currentClassName}
			onClick={onClick}
			onKeyUp={onKeyUp}
			tabIndex="0"
			aria-label="close overlay"
			role="button"
		></div>
	);
};

BodyMask.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	onKeyUp: PropTypes.func
};

export default BodyMask;
